module.exports = __webpack_public_path__ + "img/planet.c8ea329f.png";